import axios from 'axios';
import {Translation} from '../Model/TranslationOutput';
import Config from '../ConfigComponent';

const TranslationService = async (url: string) => {

  try {
    const { data } = await axios.get<Translation>(url,
      {
        headers: {
          Accept: 'application/json',
        }
      }
    );
    return data;
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      return error.message;
    }
    else
    {
      return 'An unexpected error occurred';
    }
  }

  /*
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };

    const response = await fetch('https://localhost:7011/CarSim/GetTranslation', requestOptions)
      .then(
        response=>{
          if (!response.ok) {
            throw new Error('Network response was not OK');
          }

          const contentType = response.headers.get('content-type');
          if (!contentType || !contentType.includes('application/json')) {
            throw new TypeError("Oops, we haven't got JSON!");
          }
          return response.json();
        });

        return response;
    */
}

export default TranslationService;